
{
  "fr": {
    "getQuotation": {
      "adminButtonLabel": "Envoyer le projet par mail",
      "authModalTitle": "Connectez-vous pour recevoir votre projet par mail",
      "customerButtonLabel": "Recevoir mon projet par mail"
    }
  }
}
